module.exports = "https://static.wanderu.com/static/media/de.11d88d2b.svg";